import React from "react";
import CurrentFlowStep from "../currentFlowStep";
import { ApplicationFlowPropType, ApplicationFlows } from "../types";
import ApplicationFlowProvider from "../applicationFlowContext";

export default function AdditionalAccountApplicationFlow({
  activeChapter,
  step,
  setStep,
  basicAccountApplication,
  cardApplication,
  signingProcess,
  triggerReload,
}: ApplicationFlowPropType): React.JSX.Element {
  return (
    <ApplicationFlowProvider
      flow={ApplicationFlows.ADDITIONAL_BAA}
      activeChapter={activeChapter}
      setStep={setStep}
    >
      <CurrentFlowStep
        flowType={ApplicationFlows.ADDITIONAL_BAA}
        step={step}
        setStep={setStep}
        basicAccountApplication={basicAccountApplication}
        cardApplication={cardApplication}
        signingProcess={signingProcess}
        triggerReload={triggerReload}
      />
    </ApplicationFlowProvider>
  );
}
